module.exports = __webpack_public_path__ + "img/svg/message.90b927850b2b51f6cd0896cf205f1af4.svg";